import axios from 'axios';
import {LineNonNumericYChart, LineChartDataset, LineChart} from '../common/chart';
import filter from 'lodash/filter';
import ChartPopup from '../modules/dashboardParent/components/ChartPopup';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import lang from '../lang/translator';
import moment from 'moment';
import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';
import values from 'lodash/values';

export const chartStage = {
  data() {
    return {
      persentMax: true,
      levelLineChecked: false,
      trendLineChecked: false,
      ScatterLineChecked: false,
      trendLinePoint: null,
      chosenStimul: [],
      chartDatasetsForStimul: null,
      chartDatasetsForStimulDataset: null,
      chartDatasetsHintForStimulDataset: null,
      withoutData: false,
      changesLine: [],
      dataPoint: null,
      isModalVisible: false,
    };
  },

  components: {
    LineChart, ChartPopup
  },

  methods: {

    mensurationChart(chartDatasetsForStimul){

      let pointStyle = "rect";
      let dataForChart = [];
      let dataForHintChart = [];
      let changesLine = [];

      forEach(chartDatasetsForStimul.chartData,
          (chartData, indexChart) => {

            if (indexChart == 1) {
              pointStyle = "circle";
            }
            if (indexChart == 2) {
              pointStyle = "rectRot";
            }
            if (indexChart == 3) {
              pointStyle = "triangle";
            }

            let chart = new LineChartDataset({
              data: chartData.data.values ?
                  chartData.data.values :
                  chartData.data[1].values,
              label: chartData.description,
              pointStyle: pointStyle
            });

            if (chartData.data[2] && chartData.data[2].values) {

              let datasetPromptsChart = [];

              forEach(chartData.data[2].hintResultsData, (dataItem) => {

                datasetPromptsChart.push(new LineChartDataset({
                  data: dataItem.data,
                }));

              });

              dataForHintChart.push({
                chart: datasetPromptsChart,
                label: chartData.description,
                levels: chartData.data[2].levels
              });

            }

            dataForChart.push(chart);

          });

      forEach(chartDatasetsForStimul.changes, change => {
        changesLine.push({
          x: lang.get('protocol.changes') + '_' + change.id,
          index: change.id,
          isImportant: change.isImportant,
          comment: change.comment
        })
      });

      return {
        dataForChart : dataForChart,
        dataForHintChart: dataForHintChart,
        changesLine: changesLine,
        chartDatasetsForStimul: chartDatasetsForStimul
      }


    },


    async chartShow(){
      this.loaded = false;
      this.changesLine = [];
      this.trendLinePoint = null;
      this.trendLineChecked = false;
      this.levelLineChecked = false;
      this.ScatterLineChecked = false;
      this.chartDatasetsForStimul = null;
      this.chartDatasetsForStimulDataset = null;
      this.chartDatasetsHintForStimulDataset = null;


      let chosenTaskIds = map(this.chosenStimul, 'id');

      if(chosenTaskIds.length) {

        let url = this.teachingMethod == 10 || this.teachingMethod == 9 ? this.apiChartUrl + this.protocolId + '/mensuration/'
            : this.apiChartUrl + this.protocolId + '/mensuration/' + this.stage.id;
        let params = {
          startDate: this.rangeDateStartTimestamp,
          endDate: this.rangeDateEndTimestamp,
          taskIds: JSON.stringify(chosenTaskIds)
        };

        let response = await axios.get(url, {
          params: params
        });
        let chartDatasetsForStimul = response.data.data;

        if(this.teachingMethod == 9){

          if(chartDatasetsForStimul.length){
            this.chartDatasetsForStimulDataset = [];
            this.chartDatasetsHintForStimulDataset = [];
            this.chartDatasetsForStimul = [];

            forEach(chartDatasetsForStimul, chart => {

              let result = this.mensurationChart(chart);

              this.chartDatasetsForStimulDataset.push(result.dataForChart);
              this.chartDatasetsHintForStimulDataset.push(result.dataForHintChart);
              this.chartDatasetsForStimul.push(result.chartDatasetsForStimul);
              this.changesLine.push(result.changesLine);
            });

            this.withoutData = false;

          } else{
            this.withoutData = true;
          }


          /*let result = this.mensurationChart(this.chartDatasetsForStimul[0]);

          this.chartDatasetsForStimulDataset = result.dataForChart;
          this.chartDatasetsHintForStimulDataset = result.dataForHintChart;*/
          //this.chartDatasetsForStimul[0] = result.chartDatasetsForStimul;




        } else{
          if (chartDatasetsForStimul &&
              chartDatasetsForStimul.chartData) {

            let result = this.mensurationChart(chartDatasetsForStimul);

            this.chartDatasetsForStimulDataset = result.dataForChart;
            this.chartDatasetsHintForStimulDataset = result.dataForHintChart;
            this.chartDatasetsForStimul = result.chartDatasetsForStimul;
            this.changesLine = result.changesLine;

            this.withoutData = false

          } else {
            this.withoutData = true
          }
        }


      }
      this.loaded = true;
    },

    popupShow(data,stageId){
      if(this.chosenStimul.length == 1) {

        this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
        this.selectedStageId = stageId;
        this.isModalVisible = true;

      }

    },

    onClose() {
      this.isModalVisible = false;
    },

    checkedStimulus(id) {

      let checked = false;
      if (id && this.chosenStimul.length) {
        forEach(this.chosenStimul, stimul => {
          if (stimul.stimulusId == id || stimul.id == id) {
            checked = true;
          }
        })
      }

      return checked
    },

    choseStimulus(val, checked) {
      this.isChangeStimuli = true;
      if (checked) {
        this.chosenStimul.push(val);
      } else {
        let array = filter(this.chosenStimul, item => {
          return item.name !== val.name
        });
        this.chosenStimul = array;
      }
    },

    trendLine(item) {
      let SumOfPowX = 0, SumOfX = 0, n = item.length, SumOfXY = 0, SumOfY = 0;

      for (let i = 0; i < n; i++) {
        SumOfPowX += (i + 1) * (i + 1);
        SumOfX += (i + 1);
        SumOfXY += (i + 1) * item[i].y;
        SumOfY += item[i].y;
      }
      let det = SumOfPowX * n - Math.pow(SumOfX, 2);
      let a = (SumOfXY * n - SumOfX * SumOfY) / det;
      let b = (SumOfY - a * SumOfX) / n;

      let first = a + b;
      let last = a * n + b;

      let data = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: first,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: last,
        },
      ];

      let dataset = new LineChartDataset({
        data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset

    },

    levelLine(item) {
      let n = item.length, SumOfY = 0, y = 0;

      forEach(item, point => {
        SumOfY += point.y;
      });

      y = SumOfY / n;

      let data = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: y,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: y,
        },
      ];

      let dataset = new LineChartDataset({
        data,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      return dataset

    },

    scatterLine(item) {
      let n = item.length, SumOfY = 0, y = 0;

      let min = minBy(item, function (o) {
        return o.y;
      });
      let max = maxBy(item, function (o) {
        return o.y;
      });


      let dataMin = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: min,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: min,
        },
      ];

      let dataMax = [
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[0].x,
          y: max,
        },
        {
          comment: "",
          isChanged: false,
          isImportant: false,
          x: item[n - 1].x,
          y: max,
        },
      ];

      let datasetMin = new LineChartDataset({
        data: dataMin,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      let datasetMax = new LineChartDataset({
        data: dataMax,
        borderColor: '#000',
        pointBorderWidth: 1,
        pointHoverRadius: 1,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        borderWidth: 1
      });

      let dataset = [datasetMin, datasetMax]

      return dataset

    },

    fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {

      let data = [], trendPointIndex = [], trendPoint = [], i = 0;
      let array = [];

      forEach(item, (point, index) => {

        if (point.isImportant) {
          trendPoint.push(
              array
          );
          array = [];
          trendPointIndex.push(index)
        } else {
          if (!point.isChanged) {
            array.push(point);
          }
          if (index == item.length - 1) {
            trendPoint.push(
                array
            );
          }
        }

      });
      let dataset = [];

      if (trendLine) {
        forEach(trendPoint, (point) => {
          if (point.length > 2) {
            dataset.push(this.trendLine(point));
          }
        });
      }
      if (levelLine) {
        forEach(trendPoint, (point) => {
          if (point.length > 2) {
            dataset.push(this.levelLine(point));
          }
        });
      }
      if (scatterLine) {
        forEach(trendPoint, (point) => {
          if (point.length > 2) {
            dataset.push(this.scatterLine(point)[0]);
            dataset.push(this.scatterLine(point)[1]);
          }
        });
      }

      //this.isChangeStimuli = false;

      return dataset
    },

  },

  watch: {
    levelLineChecked(newValue) {
      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartDatasetsForStimulDataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(() => {
        this.isChangeStimuli = false;
      }, 500);
    },
    trendLineChecked(newValue) {
      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartDatasetsForStimulDataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(() => {
        this.isChangeStimuli = false;
      }, 500);

    },
    ScatterLineChecked(newValue) {
      this.isChangeStimuli = true;
      if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
        this.trendLinePoint = this.fetchDatasetLineTrend(this.chartDatasetsForStimulDataset[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
      } else {
        this.trendLinePoint = null;
      }
      setTimeout(() => {
        this.isChangeStimuli = false;
      }, 500);
    },


  },

};



// WEBPACK FOOTER //
// ./src/mixins/chartStage.js